require('./insuranceRequestRelatedWizard.scss');
require('./insuranceRequestRelatedWizard.override.scss');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { PROC_STEP, recordProcess } = require('utilities/tagging');

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const { MortgageRequestManagerInfo } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerInfo/mortgageRequestManagerInfo');
const InsuranceRequestCompilationCard = require('../insuranceRequestCompilationCard/insuranceRequestCompilationCard');
const InsuranceRequestWizardStep1 = require('./insuranceRequestWizardStep1/insuranceRequestWizardStep1');
const InsuranceRequestWizardStep2Related = require('./insuranceRequestWizardStep2/insuranceRequestWizardStep2Related');
const InsuranceRequestWizardStep3 = require('./insuranceRequestWizardStep3/insuranceRequestWizardStep3');
const InsuranceRequestWizardStep5 = require('./insuranceRequestWizardStep5/insuranceRequestWizardStep5');
const InsuranceRequestDetailsTabsWrapper = require('../insuranceRequestDetails/insuranceRequestDetailsTabsWrapper');
const InsuranceRequestRelatedWizardSaved = require('./insuranceRequestRelatedWizardSaved/insuranceRequestRelatedWizardSaved');
const InsuranceRequestWizardRequestError = require('./insuranceRequestWizardRequestError/insuranceRequestWizardRequestError');
const InsuranceRequestRelatedLeaveModalWrapper = require('./insuranceRequestRelatedLeaveModalWrapper/insuranceRequestRelatedLeaveModalWrapper.js')

// @ actions
const insuranceRequestRelatedRNCWizardActions = require('../../actions/insuranceRequestRelatedRNC/insuranceRequestRelatedRNCWizard');
const insuranceRequestRelatedModify = require('../../actions/insuranceRequestRelated/insuranceRequestRelatedModify');
const insuranceRequestRelatedClear = require('../../actions/insuranceRequestRelated/insuranceRequestRelatedClear');
const insuranceRequestRelatedRNCWizardStep3 = require('../../actions/insuranceRequestRelatedRNC/insuranceRequestRelatedRNCWizardStep3');
const insuranceRequestRelatedRNCStateActions = require('../../actions/insuranceRequestRelatedRNC/insuranceRequestRelatedRNCState');
const mortgageRequestDataAction = require('actions/mortgageRequest/mortgageRequestMortgageData');
const insuranceLegalDocumentsActions = require('../../actions/insuranceLegalDocuments');

// @ constants
const { PROC_RELATED_INSURANCE, getInsuranceTag } = require('../../insuranceConstants/insuranceRequestTags');
const { MORTGAGE_PANEL } = require('../../insuranceConstants/insuranceRequestRoutes');
const { WIZARD_REQUEST_RESPONSE_OPTIONS, PROPERTY_USAGE_RELATED, PLANS: { BASIC } } = require('../../insuranceConstants/insuranceRequestHome');
const { SECOND_STEP, THIRD_STEP, FOURTH_STEP } = require('constants/index');
const { SUCCESS, IS_FETCHING, ERROR } = WIZARD_REQUEST_RESPONSE_OPTIONS;
const { INSURANCE_USABILITY_IMPROVEMENTS, INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION } = require('constants/flagBasedFeatures');

const processes = {
    PROC_PRE_APPRAISAL: 'pre-tasacion',
    PROC_POST_APPRAISAL: 'post-tasacion'
}

class InsuranceRequestRelatedRNCWizard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedPlan: BASIC,
            isCancelingSimulation: false,
            finalButtonDisabled: false
        };

        this.onhandleCancel = this.onhandleCancel.bind(this);
        this.handleChangeShowCoverageDetailTable = this.handleChangeShowCoverageDetailTable.bind(this);
        this.hasSimulationChanged = this.hasSimulationChanged.bind(this);
        this.onhandleChangeSelectedPlanInStateComponent = this.onhandleChangeSelectedPlanInStateComponent.bind(this);
        this.onhandleSelectPlanInDetailTable = this.onhandleSelectPlanInDetailTable.bind(this);
        this.cancelingSimulation = this.cancelingSimulation.bind(this);
        this.handleModifyInsurance = this.handleModifyInsurance.bind(this);
        this.savePreviousId = this.savePreviousId.bind(this);
        this.recordEvent = this.recordEvent.bind(this);
    }

    componentWillMount() {
        const { immInsuranceState, getInsurance, loadSteps } = this.props;

        if (immInsuranceState.get('data')) {
            loadSteps(immInsuranceState.get('data').toJS());
        } else {
            getInsurance();
        }
    }

    componentDidMount() {
        const { mortgageRequestMortgageData, setData } = this.props;

        const finalidad = mortgageRequestMortgageData.getIn(['data', 'finalidad'])

        if (finalidad !== '') {
            setData(SECOND_STEP, {
                propertyUsage: PROPERTY_USAGE_RELATED[finalidad]
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            immInsuranceState,
            mortgageRequestMortgageData,
            setData,
            loadSteps,
        } = this.props;

        if (nextProps.mortgageRequestMortgageData.get('data') !== mortgageRequestMortgageData.get('data')) {
            const usageRelated = nextProps.mortgageRequestMortgageData.getIn(['data', 'finalidad']);
            setData(SECOND_STEP, {
                propertyUsage: PROPERTY_USAGE_RELATED[usageRelated]
            });
        }

        if (nextProps.immInsuranceState.get('data') !== immInsuranceState.get('data')) {
            loadSteps(nextProps.immInsuranceState.get('data').toJS());
        }

        const selectedPlan = nextProps.immInsuranceWizard.getIn(["steps", THIRD_STEP, "insurancePlan"]);
        if (selectedPlan !== '' && selectedPlan !== this.state.selectedPlan) {
            this.setState({ selectedPlan });
        }
    }

    componentWillUnmount() {
        const { setLinkedSimulationToInitial, clearRequest } = this.props;
        setLinkedSimulationToInitial();
        clearRequest(null, true);
    }

    onhandleCancel() {
        this.props.history.push(MORTGAGE_PANEL);
    }

    handleChangeShowCoverageDetailTable() {
        const { setData, immInsuranceWizard } = this.props;
        setData(THIRD_STEP, {
            showDetail: !immInsuranceWizard.getIn(['steps', THIRD_STEP, 'showDetail'])
        });
    }

    savePreviousId(prevId) {
        const { setData, immInsuranceWizard } = this.props;
        const prevInsuranceId = immInsuranceWizard.getIn(['steps', FOURTH_STEP, 'prevInsuranceId']) || null;

        if (!prevInsuranceId) {
            setData(FOURTH_STEP, {
                prevInsuranceId: prevId
            });
        }
    }

    onhandleSelectPlanInDetailTable(planSelected, paymentSelected) {
        const { insuranceSelectPlan, selectPlanInRelatedWizardStep3, validateStep, immInsuranceState } = this.props;
        const { selectedPlan } = this.state;
        const isPostAppraisal = !!immInsuranceState.getIn(['appraisal', 'afterAppraisal']);

        if (paymentSelected) {
            insuranceSelectPlan(selectedPlan).then(() => {
                validateStep(FOURTH_STEP, true);
                this.handleChangeShowCoverageDetailTable();
            });
        } else {
            selectPlanInRelatedWizardStep3(selectedPlan);
            if (!isPostAppraisal) {
                validateStep(FOURTH_STEP);
            }
        }
    }

    hasSimulation() {
        const { immInsuranceState } = this.props;

        return immInsuranceState.get('data') !== null && !immInsuranceState.get('data').isEmpty();
    }

    hasSimulationChanged() {
        const { immInsuranceWizard } = this.props;

        return immInsuranceWizard.getIn(['steps', SECOND_STEP, 'simulationChanged']);

    }

    onhandleChangeSelectedPlanInStateComponent(selectedPlan) {
        this.setState({
            selectedPlan,
        });
    }

    cancelingSimulation(isCancelingSimulation) {
        this.setState({
            isCancelingSimulation,
        })
    }

    handleModifyInsurance() {
        const { validateStep, modifyInsurance, setData } = this.props;
        modifyInsurance(true, false);
        validateStep(SECOND_STEP);
        setData(FOURTH_STEP, {
            prevInsuranceId: ''
        });
    }

    recordEvent(event, extraTag) {
        const { immInsuranceWizard } = this.props;

        const step = PROC_STEP + immInsuranceWizard.get('visibleStep');
        recordProcess(PROC_RELATED_INSURANCE, step, getInsuranceTag(event, extraTag))
    }

    render() {
        const {
            changeErrorPopulation,
            changeErrorPostalCode,
            clearPostalCodeError,
            clearRequest,
            getCoveragesAndPlansData,
            getCoveragesAndPlansDetailsData,
            getDocument,
            getDocumentsSummary,
            getDocumentsZip,
            getPopulationData,
            getQuotationData,
            getRecommendation,
            immAccounts,
            immFlagBasedFeatures,
            immInsuranceLegalDocuments,
            immInsuranceRequestModify,
            immInsuranceState,
            immInsuranceWizard,
            insuranceSelectPlan,
            linkClientSuccessInitialState,
            modifyInsurance,
            mortgageRequestMortgageData,
            onPrintDocument,
            requestInsuranceRelatedRNCCurrentPricing,
            resetStep,
            selectPlanInRelatedWizardStep3,
            setData,
            setPostAppraisalInitialData,
            setVisibleStep,
            setWillCancel,
            validateStep,
        } = this.props;

        const { isCancelingSimulation } = this.state;
        const immInsuranceWizardStep2 = immInsuranceWizard.getIn(['steps', SECOND_STEP]);
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const immInsuranceWizardStep5 = immInsuranceWizard.getIn(['steps', FOURTH_STEP]);

        const isPostAppraisal = immInsuranceState.getIn(['appraisal', 'afterAppraisal']) || false;
        const isPostAppraisalClosedPrice = immInsuranceState.get('isPostAppraisalClosedPrice');
        const currentPlan = immInsuranceWizard.getIn(['steps', THIRD_STEP, 'insurancePlan']);
        const wizardRequestResponse = immInsuranceWizard.get('wizardRequestResponse');
        const linkingSimulation = immInsuranceWizardStep3.get('isLinkingInProgress');
        const islinkingSuccess = immInsuranceWizardStep3.get('islinkingSuccess');
        const linkedSimulation = immInsuranceWizardStep3.get('linkedSimulation');
        const insuranceIsBeingModified = immInsuranceRequestModify.get('insuranceIsBeingModified');
        const insuranceHasBeenModified = immInsuranceRequestModify.get('insuranceHasBeenModified');
        const insuranceModifyIsFetching = immInsuranceRequestModify.get('insuranceModifyIsFetching');
        const appraisalState = immInsuranceState.getIn(['appraisal', 'state']);
        const insuranceId = immInsuranceWizardStep3.getIn(["quotationData", "idInsurance"]);
        const showSuccess = wizardRequestResponse === SUCCESS || isPostAppraisalClosedPrice === SUCCESS && immInsuranceState.get('data');
        const showCoverageDetailTable = immInsuranceWizard.get('visibleStep') === 3 &&
            immInsuranceWizardStep3.get('showDetail');
        const showLoading = !immInsuranceState.get('hasFetched') &&
            immInsuranceState.get('isFetching') ||
            isPostAppraisalClosedPrice === IS_FETCHING ||
            wizardRequestResponse === IS_FETCHING ||
            isCancelingSimulation;
        const showSaved = !isPostAppraisal && linkedSimulation;
        const showError = wizardRequestResponse === ERROR ||
            isPostAppraisalClosedPrice === ERROR ||
            immInsuranceState.get('error') ||
            mortgageRequestMortgageData.get('error') ||
            immInsuranceWizardStep3.get('errorDetails') ||
            immInsuranceWizardStep3.get('errorQuotation') ||
            immInsuranceWizardStep3.get('cancelError') ||
            immInsuranceWizardStep3.get('error') ||
            immInsuranceWizardStep3.get('errorSelectPlan') ||
            immInsuranceWizardStep3.get('linkingError') ||
            immInsuranceWizardStep3.get('errorPricing') ||
            immInsuranceWizard.get('modifyRequestError');

        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const step2NextButtonDisabled = (isInsuranceUsabilityImprovementsEnabled && !immInsuranceWizardStep2.get('valid'));
        const preAppraisalNotificationFlag = immFlagBasedFeatures.get(INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION);

        if (insuranceModifyIsFetching) {
            return <LoadingSection />;
        } else if (showSuccess && !insuranceIsBeingModified) {
            return (
                <InsuranceRequestRelatedWizardSaved
                    isRelated
                    isPostAppraisal={isPostAppraisal}
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizardState={immInsuranceWizard}
                    hasSimulation={this.hasSimulation()}
                    hasSimulationChanged={this.hasSimulationChanged()}
                    immAccounts={immAccounts}
                    onHandleModifyInsurance={this.handleModifyInsurance}
                    onModifyInsuranceAction={modifyInsurance}
                    appraisalState={appraisalState}
                    insuranceHasBeenModified={insuranceHasBeenModified}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    isRnc
                />
            );
        } else if (showLoading) {
            return <LoadingSection />;
        } else if (showCoverageDetailTable) {
            return (
                <InsuranceRequestDetailsTabsWrapper
                    cancelingSimulation={this.cancelingSimulation}
                    clearRequest={clearRequest}
                    currentPlan={currentPlan}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizard={immInsuranceWizard}
                    isPostAppraisal={isPostAppraisal}
                    isRelated
                    isRnc
                    onChangeShowCoverageDetailTable={this.handleChangeShowCoverageDetailTable}
                    onhandleCancel={this.onhandleCancel}
                    onhandleChangeSelectedPlanInStateComponent={this.onhandleChangeSelectedPlanInStateComponent}
                    onhandleSelectPlanInDetailTable={this.onhandleSelectPlanInDetailTable}
                    selectedPlan={this.state.selectedPlan}
                    setData={setData}
                    validateStep={validateStep}
                />
            );
        } else if (showSaved) {
            return (
                <InsuranceRequestRelatedWizardSaved
                    isPostAppraisal={isPostAppraisal}
                    isRelated
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizardState={immInsuranceWizard}
                    immAccounts={immAccounts}
                    hasSimulation={this.hasSimulation()}
                    hasSimulationChanged={this.hasSimulationChanged()}
                    insuranceHasBeenModified={insuranceHasBeenModified}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                />
            );
        } else if (showError) {
            return (
                <InsuranceRequestWizardRequestError
                    buttonLabel={formatText('mortgageRequestError-returnLoans')}
                    buttonLink={MORTGAGE_PANEL}
                    setData={setData}
                    isRnc
                />
            );
        }

        const relatedWizardClasses = classNames('insurance-related-wizard', 'row', {
            'insurance-related-wizard--post-appraisal': isPostAppraisal
        });

        const wizardActions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: () => { },
            cancel: this.onhandleCancel,
            resetStep,
        };

        const tealium = {
            detalleProceso: isPostAppraisal ? processes.PROC_POST_APPRAISAL : processes.PROC_PRE_APPRAISAL
        }

        return (
            <div className={relatedWizardClasses}>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        tealium={tealium}
                        visibleStep={immInsuranceWizard.get('visibleStep')}
                        immSteps={immInsuranceWizard.get('steps')}
                        stepsAmount={immInsuranceWizard.get('steps').size}
                        isFetching={false}
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            position="first"
                            cancelButton={true}
                        >
                            <InsuranceRequestWizardStep1
                                isRelated
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={false}
                            cancelButton={true}
                            nextButton={true}
                            nextButtonDisabled={step2NextButtonDisabled}
                            position="middle"
                            previousButton={true}
                        >
                            <InsuranceRequestWizardStep2Related
                                changeErrorPopulation={changeErrorPopulation}
                                changeErrorPostalCode={changeErrorPostalCode}
                                clearPostalCodeError={clearPostalCodeError}
                                isRnc
                                isPostAppraisal={isPostAppraisal}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizardStep={immInsuranceWizardStep2}
                                getPopulationData={getPopulationData}
                                getRecommendation={getRecommendation}
                                setData={setData}
                                setPostAppraisalInitialData={setPostAppraisalInitialData}
                                getTranslation={this.getTranslation}
                                savePreviousId={this.savePreviousId}
                                recordEvent={this.recordEvent}
                            />
                        </WizardStep>
                        <WizardStep
                            position="middle"
                            cancelButton={true}
                            previousButton={true}
                            nextButton={true}
                            addLoadingBehaviour={false}
                            isLoading={(linkingSimulation && !linkedSimulation) || islinkingSuccess}
                        >
                            <InsuranceRequestWizardStep3
                                getCoveragesAndPlansData={getCoveragesAndPlansData}
                                getCoveragesAndPlansDetailsData={getCoveragesAndPlansDetailsData}
                                getQuotationData={getQuotationData}
                                hasSimulationChanged={this.hasSimulationChanged()}
                                immAccounts={immAccounts}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizard={immInsuranceWizard}
                                insuranceSelectPlan={insuranceSelectPlan}
                                isPostAppraisal={isPostAppraisal}
                                isRelated
                                isRnc
                                linkClientSuccessInitialState={linkClientSuccessInitialState}
                                onChangeShowCoverageDetailTable={this.handleChangeShowCoverageDetailTable}
                                onhandleChangeSelectedPlanInStateComponent={this.onhandleChangeSelectedPlanInStateComponent}
                                recordEvent={this.recordEvent}
                                requestInsuranceRelatedRNCCurrentPricing={requestInsuranceRelatedRNCCurrentPricing}
                                selectPlanInRelatedWizardStep3={selectPlanInRelatedWizardStep3}
                                setData={setData}
                                validateStep={validateStep}
                            />
                        </WizardStep>
                        <WizardStep
                            position="last"
                            cancelButton={true}
                            previousButton={true}
                            finishButton={false}
                            addLoadingBehaviour={false}
                            immFinalButton="common-confirm"
                            finalButtonDisabled={!immInsuranceWizardStep5.get('acceptedConditions')}
                        >
                            <InsuranceRequestWizardStep5
                                getDocument={getDocument}
                                getDocumentsSummary={getDocumentsSummary}
                                getDocumentsZip={getDocumentsZip}
                                getPaymentAccount={() => { }}
                                hasSimulation={this.hasSimulation()}
                                hasSimulationChanged={this.hasSimulationChanged()}
                                immAccounts={immAccounts}
                                immFlagBasedFeatures={immFlagBasedFeatures}
                                immInsuranceLegalDocuments={immInsuranceLegalDocuments}
                                immInsuranceState={immInsuranceState}
                                immInsuranceWizardPrevStep={immInsuranceWizardStep3}
                                immInsuranceWizardState={immInsuranceWizard}
                                immInsuranceWizardStep={immInsuranceWizardStep5}
                                isPostAppraisal={isPostAppraisal}
                                isRelated
                                isRnc
                                onPrintDocument={onPrintDocument}
                                setData={setData}
                            />
                        </WizardStep>
                    </Wizard>
                </div>

                <div className="col-xs-12 col-md-4">
                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                        <div className="insurance-related-wizard__manager">
                            <MortgageRequestManagerInfo
                                managerTitle={formatText('mortgageRequestManagerInfo-yourManager')}
                            />
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                        <InsuranceRequestCompilationCard
                            isRnc
                            isRelated
                            immInsuranceState={immInsuranceState}
                            immInsuranceWizardState={immInsuranceWizard}
                            hasSimulation={this.hasSimulation()}
                            hasSimulationChanged={this.hasSimulationChanged()}
                            preAppraisalNotificationFlag={preAppraisalNotificationFlag}
                        />
                    </div>
                </div>
                <InsuranceRequestRelatedLeaveModalWrapper
                    immInsuranceWizard={immInsuranceWizard}
                    clearRequest={clearRequest}
                    cancelingSimulation={this.cancelingSimulation}
                    insuranceIsBeingModified
                    insuranceId={insuranceId}
                    isRnc
                />
            </div>
        );
    }
}

InsuranceRequestRelatedRNCWizard.propTypes = {
    changeErrorPostalCode: PropTypes.func.isRequired,
    changeErrorPopulation: PropTypes.func.isRequired,
    clearPostalCodeError: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizard: PropTypes.object.isRequired,
    immInsuranceLegalDocuments: PropTypes.object.isRequired,
    immInsuranceRequestModify: PropTypes.object.isRequired,
    mortgageRequestMortgageData: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    getRecommendation: PropTypes.func.isRequired,
    loadSteps: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setLinkedSimulationToInitial: PropTypes.func,
    setWillCancel: PropTypes.func.isRequired,
    getDocument: PropTypes.func.isRequired,
    getDocumentsSummary: PropTypes.func.isRequired,
    getPopulationData: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    getDocumentsZip: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    setPostAppraisalInitialData: PropTypes.func,
    requestMortgageData: PropTypes.func,
    getQuotationData: PropTypes.func.isRequired,
    getCoveragesAndPlansData: PropTypes.func.isRequired,
    getCoveragesAndPlansDetailsData: PropTypes.func.isRequired,
    insuranceSelectPlan: PropTypes.func.isRequired,
    getInsurance: PropTypes.func.isRequired,
    selectPlanInRelatedWizardStep3: PropTypes.func.isRequired,
    modifyInsurance: PropTypes.func.isRequired,
    linkClientSuccessInitialState: PropTypes.func,
    requestInsuranceRelatedRNCCurrentPricing: PropTypes.func.isRequired,
    resetStep: PropTypes.func,
    history: PropTypes.object.isRequired,
};

InsuranceRequestRelatedRNCWizard.defaultProps = {
    setLinkedSimulationToInitial: () => { },
    linkClientSuccessInitialState: () => { },
};

module.exports.constructor = InsuranceRequestRelatedRNCWizard;

module.exports.InsuranceRequestRelatedRNCWizard = withRouter(connect(state => (
    {
        immInsuranceState: state.insuranceRequestRelatedRNCState,
        immInsuranceWizard: state.insuranceRequestRelatedRNCWizard,
        immInsuranceRequestModify: state.insuranceRequestModify,
        mortgageRequestMortgageData: state.mortgageRequestMortgageData,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immInsuranceLegalDocuments: state.insuranceRequestLegalDocuments,
        immAccounts: state.accounts
    }),
    {
        changeErrorPostalCode: insuranceRequestRelatedRNCWizardActions.changeErrorPostalCode,
        changeErrorPopulation: insuranceRequestRelatedRNCWizardActions.changeErrorPopulation,
        clearPostalCodeError: insuranceRequestRelatedRNCWizardActions.clearPostalCodeError,
        validateStep: insuranceRequestRelatedRNCWizardActions.validateStep,
        getRecommendation: insuranceRequestRelatedRNCStateActions.requestInsuranceRelatedRNCRecommendation,
        setData: insuranceRequestRelatedRNCWizardActions.setData,
        setPostAppraisalInitialData: insuranceRequestRelatedRNCWizardActions.setPostAppraisalInitialData,
        setVisibleStep: insuranceRequestRelatedRNCWizardActions.setVisibleStep,
        setWillCancel: insuranceRequestRelatedRNCWizardActions.setWillCancel,
        getPopulationData: insuranceRequestRelatedRNCWizardActions.getPopulationData,
        getDocument: insuranceRequestRelatedRNCWizardActions.getDocument,
        getDocumentsSummary: insuranceLegalDocumentsActions.getDocumentsSummary,
        onPrintDocument: insuranceLegalDocumentsActions.onPrintDocument,
        getDocumentsZip: insuranceLegalDocumentsActions.getDocumentsZip,
        loadSteps: insuranceRequestRelatedRNCWizardActions.loadSteps,
        requestMortgageData: mortgageRequestDataAction.requestMortgageData,
        getQuotationData: insuranceRequestRelatedRNCWizardStep3.getQuotationData,
        setLinkedSimulationToInitial: insuranceRequestRelatedRNCWizardStep3.setLinkedSimulationToInitial,
        getCoveragesAndPlansData: insuranceRequestRelatedRNCWizardStep3.getCoveragesAndPlansData,
        getCoveragesAndPlansDetailsData: insuranceRequestRelatedRNCWizardStep3.getCoveragesAndPlansDetailsData,
        insuranceSelectPlan: insuranceRequestRelatedRNCWizardStep3.linkClient,
        linkClientSuccessInitialState: insuranceRequestRelatedRNCWizardStep3.linkClientSuccessInitialState,
        selectPlanInRelatedWizardStep3: insuranceRequestRelatedRNCWizardStep3.selectPlanInRelatedWizardStep3,
        getInsurance: insuranceRequestRelatedRNCStateActions.requestInsuranceRelatedRNCCurrentState,
        requestInsuranceRelatedRNCCurrentPricing: insuranceRequestRelatedRNCStateActions.requestInsuranceRelatedRNCCurrentPricing,
        modifyInsurance: insuranceRequestRelatedModify.modifyInsurance,
        clearRequest: insuranceRequestRelatedClear.clearRequest,
        resetStep: insuranceRequestRelatedRNCWizardActions.resetStep
    }
)(InsuranceRequestRelatedRNCWizard));
